export enum PrimaryComplain {
  BillingFinancial = 'BILLING_FINANCIAL',
  AbuseNeglect = 'ABUSE_NEGLET',
  InjuryAccident = 'INJURY_ACCIDENT',
  ServiceQualityOfCare = 'SERVICE_QUALITY_OF_CARE',
}
